import { isNil } from 'lodash'

const PERMISSIONS = {
    admin: {
        users: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
    },
    gdl: {
        instances: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        settingLicenses: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        commercial: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        customers: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        license: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
    },
    support: {
        versions: {
            view: true,
        },
        instances: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        statisticsSupervision: {
            view: true,
        },
        customers: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        dashboardSupport: {
            view: true,
        },
        issue: {
            view: true,
        },
        statistics: {
            view: true,
        },
        devs: {
            view: true,
            create: true,
            update: true,
        },
        roadmap: {
            view: true,
        },
    },
    supervision: {
        instances: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        services: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        timeErrors: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        statisticsSupervision: {
            view: true,
        },
        issue: {
            view: true,
        },
        dashboardSupport: {
            view: true,
        },
        recette: {
            view: true,
        },
        versions: {
            view: true,
        },
        dashboardProd: {
            view: true,
        },
    },
    developer: {
        instances: {
            view: true,
        },
        services: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        statistics: {
            view: true,
        },
        tickets: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        devs: {
            view: true,
            create: true,
            update: true,
            delete: true,
        },
        recette: {
            view: true,
        },
        versions: {
            view: true,
        },
        roadmap: {
            view: true,
        },
    },
}

const hasPermission = (user = {}, resource = '', action = '', data) => {
    if (isNil(user.habs)) return false
    return user.habs.some(role => {
        const permission = PERMISSIONS[role]?.[resource]?.[action] ?? false
        if (typeof permission === 'boolean') return permission
        return permission(user, data)
    })
}

export { hasPermission, PERMISSIONS }
